import { render, staticRenderFns } from "./MemberAccessNi.vue?vue&type=template&id=4bd7ec7a"
import script from "./MemberAccessNi.vue?vue&type=script&lang=js"
export * from "./MemberAccessNi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports